import moment from 'moment';
import { forwardRef } from 'react';
import Text from 'shell/components/Text';

export default forwardRef((props, ref) => {
    return (
        <Text ref={ref} {...props} color={'light'} variant={'p3'}>
            © Copyright TimelyGrader {moment().format('YYYY')}
        </Text>
    );
});
